<template>
  <div>
    <modal-form modal-id="create-task">
      <div slot="title">Create Task</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12">
            <h3>{{ pbn.domain }}</h3>
            <h4 v-if="order">{{ order.name }}</h4>
          </div>
          <div class="col-lg-12 m-t-xs">
            <v-select v-if="pbn && pbn.client && !order" :options="maintenanceOrders.filter(o => o.client.id === pbn.client.id)" v-model="task['order']" placeholder="Order" label="name" index="id"></v-select>
          </div>
          <div class="col-lg-12 m-t-xs" v-if="order || this.task.order">
            Create all types of task for this order? <input type="checkbox" name="" id="" v-model.number="task['createOtherTypes']">
          </div>
          <div class="col-lg-12 m-t-xs">
            <input type="text" class="form-control" disabled :value="type" v-if="type">
              <v-select v-else :options="['content','fix','tech','links','build']" v-model="task['type']" placeholder="Type" required></v-select>
          </div>
          <div class="col-lg-12 m-t-xs">
            <input type="text" class="form-control" placeholder="Title" v-model="task['title']" required>
          </div>
          <div class="col-lg-12 m-t-xs">
            <textarea class="form-control" placeholder="description..." v-model="task['description']" cols="30" rows="10"></textarea>
          </div>
          <div class="col-lg-12 m-t-xs">
            <v-select :options="f.users" index="id" label="name" placeholder="Assignee" v-model="task['assignee']"></v-select>
          </div>
          <div class="col-lg-12 m-t-xs">
            <v-select :options="[{id: 1, label: 'Low'}, {id: 2, label: 'Medium'}, {id: 3, label: 'High'}]" placeholder="Priority" index="id" v-model="task['priority']"></v-select>
          </div>
          <div class="col-lg-12 m-t-sm">
            <button class="btn btn-sm btn-primary" @click="createTask(false)"><i class="fa fa-plus"></i> Create Task</button>
            <button class="btn btn-sm btn-success" @click="createTask(true)"><i class="fa fa-share"></i> Create And Go To Task</button>
          </div>
        </div>
      </div>
    </modal-form>
  </div>
</template>
<script>
import Form from '../../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  data () {
    return {
      task: {}
    }
  },
  components: {
    modalForm: Form
  },
  mounted () {
    if (!this.f.users || !this.f.users.length) {
      this.$store.dispatch('loadFilters')
      this.task = {...this.data}
    }
    if (!this.order && this.user.admin) {
      this.$store.dispatch('loadMaintenanceOrders')
    }
  },
  props: ['order', 'pbn', 'type', 'data'],
  computed: {
    ...mapGetters({
      f: 'getFilters',
      maintenanceOrders: 'getMaintenanceOrders',
      user: 'getUser'
    })
  },
  methods: {
    createTask (follow = false) {
      let data = this.task
      data.pbn = this.pbn.id

      if (data.title === '') {
        data.title = this.type
      }

      if (this.type) {
        data.type = this.type
      }

      if (this.order) {
        data.order = this.order.id
      }

      axios.post(`/maintenance/task`, data)
        .then(r => {
          this.$toastr.success('Task successfully created')
          if (follow === true) {
            this.$router.push(`/maintenance/task/${r.data.task.id}`)
          }
          $('#create-task').modal('hide')
          this.$emit('taskCreated', r.data.task)
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Order/CreateTaskModal.vue